import {createAsyncThunk} from '@reduxjs/toolkit';
// eslint-disable-next-line no-unused-vars
import api from 'services/axios';

export const getDoneCustomDeals = createAsyncThunk<any, any>(
  'getDoneCustomDeals',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`/dasht/custom_deal`, {
        params,
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getInProgressCustomDeals = createAsyncThunk<any, any>(
  'getInProgressCustomDeals',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`/dasht/custom_deal/inprogress?vendor_id=${params.vendorId}`, {
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const customDealsCats = createAsyncThunk<any, any>(
  'customDealsCats',
  async (params, thunkApi) => {
    try {
      // MOCK DATA FOR TESTING - REMOVE THIS
      // await new Promise((resolve) => setTimeout(resolve, 300)); // Simulate network delay
      // return thunkApi.fulfillWithValue(mockCat);

      const response = await api.get(`/dasht/products/categories`, {
        params: {
          vendor_id: params.vendor_id
        },
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const customDealsSubCats = createAsyncThunk<any, any>(
  'customDealsSubCats',
  async (params, thunkApi) => {
    try {
      // MOCK DATA FOR TESTING - REMOVE THIS
      // await new Promise((resolve) => setTimeout(resolve, 300)); // Simulate network delay
      // return thunkApi.fulfillWithValue(mockSubCat);

      // UNCOMMENT THIS FOR ACTUAL API CALL
      const response = await api.get(`/dasht/products/categories/${params.parent_id}/children`, {
        params: {
          vendor_id: params.vendor_id
        },
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getProducts = createAsyncThunk<any, any>('getProducts', async (params, thunkApi) => {
  try {
    // // MOCK DATA FOR TESTING - REMOVE THIS
    // await new Promise((resolve) => setTimeout(resolve, 500)); // Simulate network delay
    // const mockResponse = {
    //   ...mockProducts,
    //   page: params.page || 1, // Use the requested page
    //   size: params.page_size || mockProducts.size
    // };
    // return thunkApi.fulfillWithValue(mockResponse);

    const response = await api.get(`/dasht/products`, {
      params: {
        vendor_id: params.vendor_id,
        search: params.search,
        stock_status: params.stock_status,
        badge: params.badge,
        ptk: params.ptk,
        page_size: params.page_size,
        page: params.page,
        sort: params.sort,
        category_id: params.category_id
      },
      goBaseUrl: true
    });

    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});

export const addBulkProductsToDraftDeal = createAsyncThunk<any, any>(
  'addBulkProductsToDraftDeal',
  async ({vendorId, productIds}, thunkApi) => {
    try {
      // // MOCK DATA FOR TESTING - REMOVE THIS
      // await new Promise((resolve) => setTimeout(resolve, 500)); // Simulate network delay
      // const mockResponse = {
      //   deal_id: 2
      // };
      // return thunkApi.fulfillWithValue(mockResponse);

      const response = await api.put(
        `/dasht/custom_deal/deals/products`,
        {
          products: productIds
        },
        {
          params: {
            vendor_id: vendorId
          },
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e?.data || e);
    }
  }
);

export const getDealProducts = createAsyncThunk<any, any>(
  'getDealProducts',
  async (params, thunkApi) => {
    try {
      // // MOCK DATA FOR TESTING - REMOVE THIS
      // await new Promise((resolve) => setTimeout(resolve, 500)); // Simulate network delay
      // const mockResponse = {
      //   size: 3417,
      //   current_page: params.page || 1,
      //   total_items: 8346,
      //   first_request: false,
      //   total_pages: 7288,
      //   current: [
      //     {
      //       id: 7904,
      //       discount: 2491,
      //       parent_category_id: 3661,
      //       title: 'string',
      //       price: 7656,
      //       discounted_price: 4981.4395068933745,
      //       stock: 4909
      //     },
      //     {
      //       id: 8403,
      //       discount: 8106,
      //       parent_category_id: 3184,
      //       title: 'string',
      //       price: 5872,
      //       discounted_price: 3892.387083402484,
      //       stock: 780
      //     }
      //   ]
      // };
      // return thunkApi.fulfillWithValue(mockResponse);

      const query = new URLSearchParams();
      query.set('vendor_id', String(params.vendor_id));
      query.set('page', String(params.page));
      query.set('page_size', String(params.page_size));
      if (params.search) query.set('search', String(params.search));
      if (params.stock_status != null) query.set('stock_status', String(params.stock_status));
      if (params.badge != null) query.set('badge', String(params.badge));
      if (params.ptk != null) query.set('ptk', String(params.ptk));
      if (params.sort) query.set('sort', String(params.sort));

      (params.parent_category_ids || []).forEach((id) => {
        if (id != null) query.append('parent_category_ids', String(id));
      });

      const response = await api.get(`/dasht/custom_deal/deals/${params.deal_id}/products`, {
        params: query,
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e?.data || e);
    }
  }
);

export const getDealProductDiscountIds = createAsyncThunk<any, any>(
  'getDealProductDiscountIds',
  async ({vendorId, dealId}, thunkApi) => {
    try {
      const response = await api.get(`/dasht/custom_deal/deals/${dealId}/products/ids`, {
        params: {
          vendor_id: vendorId
        },
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e?.data || e);
    }
  }
);

export const getDealCategories = createAsyncThunk<any, any>(
  'getDealCategories',
  async ({dealId, vendorId}, thunkApi) => {
    try {
      // // MOCK DATA FOR TESTING - REMOVE THIS
      // await new Promise((resolve) => setTimeout(resolve, 300)); // Simulate network delay
      // const mockResponse = [
      //   {
      //     id: 7593,
      //     title: 'string',
      //     product_count: 1436
      //   },
      //   {
      //     id: 7401,
      //     title: 'string',
      //     product_count: 881
      //   }
      // ];
      // return thunkApi.fulfillWithValue(mockResponse);

      const response = await api.get(`/dasht/custom_deal/deals/${dealId}/categories`, {
        params: {
          vendor_id: vendorId
        },
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e?.data || e);
    }
  }
);

export const getDealSummary = createAsyncThunk<any, any>(
  'getDealSummary',
  async ({vendorId, dealId}, thunkApi) => {
    try {
      const response = await api.get(`/dasht/custom_deal/deals/${dealId}/summary`, {
        params: {
          vendor_id: vendorId
        },
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e?.data || e);
    }
  }
);

export const updateBulkProductDiscount = createAsyncThunk<any, any>(
  'updateBulkProductDiscount',
  async ({dealId, vendorId, productIds, discount}, thunkApi) => {
    try {
      const response = await api.put(
        `/dasht/custom_deal/deals/${dealId}/products`,
        {
          product_id: Array.from(productIds),
          discount: discount
        },
        {
          params: {
            vendor_id: vendorId
          },
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e?.data || e);
    }
  }
);

export const updateProductDiscount = createAsyncThunk<any, any>(
  'updateProductDiscount',
  async ({dealId, vendorId, productId, discount}, thunkApi) => {
    try {
      const response = await api.put(
        `/dasht/custom_deal/deals/${dealId}/products/${productId}`,
        {
          discount: discount
        },
        {
          params: {
            vendor_id: vendorId
          },
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e?.data || e);
    }
  }
);

export const deleteProductFromDeal = createAsyncThunk<any, any>(
  'deleteProductFromDeal',
  async ({dealId, vendorId, productId}, thunkApi) => {
    try {
      const response = await api.delete(
        `/dasht/custom_deal/deals/${dealId}/products/${productId}`,
        {
          params: {
            vendor_id: vendorId
          },
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response || {status: 'success'});
    } catch (e: any) {
      return thunkApi.rejectWithValue(e?.data || e);
    }
  }
);

export const confirmDeal = createAsyncThunk<any, any>(
  'confirmDeal',
  async ({vendorId, startDate, endDate}, thunkApi) => {
    try {
      const response = await api.put(
        `/dasht/custom_deal/deals/confirm`,
        {
          start_date: startDate,
          end_date: endDate
        },
        {
          params: {
            vendor_id: vendorId
          },
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e?.data || e);
    }
  }
);

export const deleteOrPauseDeal = createAsyncThunk<any, any>(
  'deleteOrPauseDeal',
  async ({dealId, vendorId}, thunkApi) => {
    try {
      const response = await api.delete(`/dasht/custom_deal/deals/${dealId}`, {
        params: {
          vendor_id: vendorId
        },
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response?.data || {status: 'success'});
    } catch (e: any) {
      return thunkApi.rejectWithValue(e?.data || e);
    }
  }
);
